import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { AddTeamModelDialogComponent } from './add-team-model-dialog.component';
import { MaterialModule } from 'src/app/material.module';
import { SharedModule } from 'src/app/shared/shared.module';



@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    SharedModule,
    ReactiveFormsModule
  ],
  declarations: [
    AddTeamModelDialogComponent 
  ],
  exports: [
    AddTeamModelDialogComponent
  ],
  entryComponents: [
    AddTeamModelDialogComponent
  ]
})
export class AddTeamModelDialogModule { }
